import React, { createContext, useContext, useEffect, useState } from 'react'

const DEFAULT_LANG = 'EL'
const STORAGE_KEY = 'preferredLang'

const LanguageContext = createContext({ lang: DEFAULT_LANG, switchLanguage: () => {} })

// localStorage throws when storage is blocked (e.g. some privacy modes).
const readPreferredLang = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

/**
 * Provides the language of the current page. gatsby-node passes it in every page's
 * context, so it's right during server rendering too; pages without one (the 404
 * page) fall back to the visitor's last choice in the language switcher.
 */
export const LanguageProvider = ({ lang: pageLang, children }) => {
  const [preferredLang, setPreferredLang] = useState(null)

  useEffect(() => {
    if (!pageLang) setPreferredLang(readPreferredLang())
  }, [pageLang])

  const switchLanguage = (newLang) => {
    setPreferredLang(newLang)
    try {
      window.localStorage.setItem(STORAGE_KEY, newLang)
    } catch {
      // Not remembered beyond this visit.
    }
  }

  const lang = pageLang || preferredLang || DEFAULT_LANG

  return (
    <LanguageContext.Provider value={{ lang, switchLanguage }}>{children}</LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
